import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard-fatura-eletronica',
  templateUrl: './dashboard-fatura-eletronica.component.html',
  styleUrls: ['./dashboard-fatura-eletronica.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardFaturaEletronicaComponent implements OnInit, OnDestroy {

  @Input() temDadosEmpresa = false;
  @Input() temCertificadoDigital = false;
  @Input() temTimbradoEletronico = false;
  @Input() temVendaTimbrado = false;

  @Output() dismiss = new EventEmitter<void>();

  texts = {
    fatura_eletronica: '',
    dados_empresa: '',
    certificado_digital: '',
    timbrado_eletronico: '',
    venda_timbrado: '',
    tutorial_como_fazer: '',
    nao_mostrar_mais: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private loadTranslations(): void {
    this.texts = {
      fatura_eletronica: this.translate.instant('dashboard.texts.fatura_eletronica'),
      dados_empresa: this.translate.instant('dashboard.texts.dados_empresa'),
      certificado_digital: this.translate.instant('dashboard.texts.certificado_digital'),
      timbrado_eletronico: this.translate.instant('dashboard.texts.timbrado_eletronico'),
      venda_timbrado: this.translate.instant('dashboard.texts.venda_timbrado'),
      tutorial_como_fazer: this.translate.instant('dashboard.texts.tutorial_como_fazer'),
      nao_mostrar_mais: this.translate.instant('dashboard.texts.nao_mostrar_mais')
    };
  }

  onDismiss(): void {
    this.dismiss.emit();
  }

  get progresso(): number {
    let concluidas = 0;
    if (this.temDadosEmpresa) concluidas++;
    if (this.temCertificadoDigital) concluidas++;
    if (this.temTimbradoEletronico) concluidas++;
    if (this.temVendaTimbrado) concluidas++;
    return Math.round((concluidas / 4) * 100);
  }

  irParaConfigEmpresa(): void {
    this.router.navigate(['/configuracoes-da-empresa']);
  }

  irParaTimbrado(): void {
    this.router.navigate(['/timbrado']);
  }

  irParaVendas(): void {
    this.router.navigate(['/vendas']);
  }
}
